  (async () => {
    // ── Only run if customer is logged in ──────────────────────────────────────
    // These must be injected by Liquid before this script runs:
    //
    
    //
    const { apiBase, shop, customerId } = window.__wishlistConfig ?? {};
    if (!customerId || !shop) return; // guest — nothing to sync

    try {
      // ── Fetch server wishlist ────────────────────────────────────────────────
      const params = new URLSearchParams({ shop, logged_in_customer_id: customerId });
      const res    = await fetch(`${apiBase}?${params}`);
      const data   = await res.json();

      if (!data.ok) return;

      // ── Build handle arrays from server response ─────────────────────────────
      const serverHandles  = (data.wishlistedItems ?? []).map(i => i.productHandle).filter(Boolean);
      const serverIHaveIt  = (data.iHaveIt         ?? []).map(i => i.productHandle).filter(Boolean);

      // ── Merge with any localStorage items added while logged out ─────────────
      // (e.g. guest added items in normal window, then logged in via incognito)
      const localHandles   = JSON.parse(localStorage.getItem("wishlistItem")  ?? "[]");
      const localIHaveIt   = JSON.parse(localStorage.getItem("iHaveItItem")   ?? "[]");

      // Deduplicated union — server is source of truth, local additions appended
      const mergedHandles  = [...new Set([...serverHandles,  ...localHandles])];
      const mergedIHaveIt  = [...new Set([...serverIHaveIt,  ...localIHaveIt])];

      // ── Persist any local-only items back to the server ──────────────────────
      const onlyLocal = localHandles.filter(h => !serverHandles.includes(h));
      if (onlyLocal.length > 0) {
        await Promise.allSettled(
          onlyLocal.map(handle =>
            fetch(`${apiBase}?${params}`, {
              method: "POST",
              body: (() => {
                const fd = new FormData();
                fd.append("_action",       "CREATE");
                fd.append("productHandle", handle);
                fd.append("productId",     handle); // fallback; replace if you store productId
                fd.append("type",          "wishlist");
                return fd;
              })(),
            })
          )
        );
      }

      // ── Write merged data to localStorage ────────────────────────────────────
      localStorage.setItem("wishlistItem", JSON.stringify(mergedHandles));
      if (mergedIHaveIt.length) {
        localStorage.setItem("iHaveItItem", JSON.stringify(mergedIHaveIt));
      }

      // ── Sync all wishlist toggle buttons on the page ─────────────────────────
      document.querySelectorAll("[data-wishlist][data-wishlist-handle]").forEach(btn => {
        const handle   = btn.dataset.wishlistHandle;
        const isAdded  = mergedHandles.includes(handle);
        const label    = btn.querySelector(".text");

        btn.classList.toggle("wishlist-added", isAdded);
        if (label) {
          label.textContent = isAdded
            ? (window.wishlist?.added   ?? "Added")
            : (window.wishlist?.add     ?? "Add to Wishlist");
        }
      });

      // ── Sync iHaveIt buttons if present ──────────────────────────────────────
      document.querySelectorAll("[data-i-have-it][data-wishlist-handle]").forEach(btn => {
        const handle  = btn.dataset.wishlistHandle;
        const isAdded = mergedIHaveIt.includes(handle);
        btn.classList.toggle("i-have-it-added", isAdded);
      });

      // ── Notify any live wishlist-view component on the page ──────────────────
      // (covers the edge case where wishlist-view is on the same page, e.g. a
      //  drawer/modal, and initialised before the sync completed)
      document.dispatchEvent(new CustomEvent("wishlistsynced", {
        detail: { handles: mergedHandles, iHaveIt: mergedIHaveIt }
      }));

    } catch (err) {
      // Non-fatal — UI falls back to whatever is already in localStorage
      console.warn("[wishlist-sync]", err.message);
    }
  })();
